// Variable naming convention
// [component] + Styles + [Section] + [Variation]
// Styles split into sections of 'DefaultTheme', 'DarkTheme', 'Structure', and 'Typography'
// Examples: dropDownStylesStructureWide or buttonStylesDarkThemePrimary

//The styles below are old and either out of date or not confirmed corrrect, use them with caution

export const dropDownStylesDefaultTheme = [
	{
		name: 'Background',
		property: 'background-color',
		value: 'F8F9F9',
		isColorTile: true,
	},
	{
		name: 'Border',
		property: 'border-color',
		value: 'd1d1d6',
		isColorTile: true,
	},
	{
		name: 'Item Row Background',
		property: 'background-color',
		value: 'F8F9F9',
		isColorTile: true,
	},
	{
		name: 'Item Row Text',
		property: 'color',
		value: '15293A',
		isColorTile: true,
	},
	{
		name: 'Item Row Background (Selected)',
		property: 'background-color',
		value: 'D3F0F7',
		isColorTile: true,
	},
	{
		name: 'Item Row Text(Selected)',
		property: 'color',
		value: '15293A',
		isColorTile: true,
	},
	{
		name: 'Item Row Background: hover',
		property: 'background-color',
		value: 'E9EBEC',
		isColorTile: true,
	},
];

export const dropDownStylesDarkTheme = [
	{
		name: 'Background',
		property: 'background-color',
		value: '121212',
		isColorTile: true,
	},
	{
		name: 'Border',
		property: 'border-color',
		value: '949494',
		isColorTile: true,
	},
	{
		name: 'Item Row Background',
		property: 'background-color',
		value: '121212',
		isColorTile: true,
	},
	{
		name: 'Item Row Text',
		property: 'color',
		value: 'E7E9E9',
		isColorTile: true,
	},
	{
		name: 'Item Row Background (Selected)',
		property: 'background-color',
		value: '125667',
		isColorTile: true,
	},
	{
		name: 'Item Row Text(Selected)',
		property: 'color',
		value: 'E7E9E9',
		isColorTile: true,
	},
	{
		name: 'Item Row Background: hover',
		property: 'background-color',
		value: '3b3b3b',
		isColorTile: true,
	},
];

export const dropDownStylesTypography = [
	{
		name: 'Text',
		property: 'font-family',
		value: '"Inter Regular", sans-serif',
		isColorTile: false,
	},
	{
		name: '',
		property: 'font-size',
		value: '0.875rem',
		isColorTile: false,
	},
	{
		name: '',
		property: '',
		value: '14px',
		isColorTile: false,
	},
	{
		name: '',
		property: 'font-weight',
		value: 'regular / 400',
		isColorTile: false,
	},
	{
		name: '',
		property: 'line-height',
		value: '1.25rem',
		isColorTile: false,
	},
	{
		name: '',
		property: '',
		value: '20px',
		isColorTile: false,
	},
];

export const dropDownStylesStructure = [
	{
		name: 'Container',
		property: 'min-width',
		value: '240px',
		isColorTile: false,
	},
	{
		name: '',
		property: 'max-width',
		value: '400px',
		isColorTile: false,
	},
	{
		name: 'Container (area before first item row)',
		property: 'padding-top',
		value: '8px',
		isColorTile: false,
	},
	{
		name: 'Container (area after last item row)',
		property: 'padding-bottom',
		value: '8px',
		isColorTile: false,
	},
	{
		name: 'Item Row',
		property: 'height',
		value: '48px',
		isColorTile: false,
	},
	{
		name: '',
		property: 'padding-left',
		value: '16px',
		isColorTile: false,
	},
	{
		name: '',
		property: 'padding-right',
		value: '16px',
		isColorTile: false,
	},
	{
		name: '',
		property: 'padding-up',
		value: '12px',
		isColorTile: false,
	},
	{
		name: '',
		property: 'padding-down',
		value: '12px',
		isColorTile: false,
	},
	{
		name: '',
		property: 'min-height',
		value: '48px',
		isColorTile: false,
	},
];
